import Constants from '../actions/types';

const initialState = {
  customFields: [],
  entityFields: [],
  allFields: []
};

const fieldsReducer = (state = initialState, action) => {
  switch (action.type) {
    // First time we load entities
    case Constants.FIELDS_FIRST_ENTITY: {
      const newEntityFields = action.payload
        ? action.payload[0].attribute.map(attrib => attrib.name)
        : [];
      return {
        customFields: state.customFields,
        entityFields: newEntityFields,
        allFields: [...newEntityFields, ...state.customFields]
      };
    }

    // We got custom fields
    case Constants.FIELDS_GET_CUSTOMFIELDS: {
      const newCustomFields = action.payload
        ? action.payload.map(attrib => attrib.fieldName)
        : [];
      return {
        customFields: newCustomFields,
        entityFields: state.entityFields,
        allFields: [...state.entityFields, ...newCustomFields]
      };
    }

    // When the selected entity changes, we need to clear the search fields
    case Constants.ENTITY_SELECT: {
      const newEntityFields = action.payload
        ? action.payload.attribute.map(attrib => attrib.name)
        : [];
      return {
        customFields: state.customFields,
        entityFields: newEntityFields,
        allFields: [...newEntityFields, ...state.customFields]
      };
    }

    default: {
      return state;
    }
  }
};

export default fieldsReducer;
